export default __webpack_public_path__ + "static/media/cp_geo_tf.a0a0fd59.svg";